<template>
  <div class="container-fluid">

    <div class="row">
      <div class="col-lg-12">
        <div class="row">
          <img id="single-brand-301-image" :src="brand.image" :alt="brand.name"/>
          <div class="">
            <h4 class="single-brand-301-title">{{ brand.name }}</h4>
            <div v-if="brand.description != null" v-html="brand.description" class="single-brand-301-description"></div>
          </div>
        </div>
      </div>
    </div>

    <div class="container my-5">
      <div class=" col text-center">
        <h3 v-t="`brand.single.brand_items_title`"></h3>
      </div>
      <hr>

      <div class="row">

        <div class="col-lg-4 mt-3" v-for="product in products" :key="product.id">
          <m-product-card309 :product="product"/>
        </div>


      </div>

      <div class="row text-center mt-3 ">
        <div class="col-lg-12">
          <m-paginate1 :meta="meta" :onChangePage="changePage"/>
        </div>
      </div>


    </div>

  </div>

</template>

<script>
import {convertToJalaliWithTime} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/Converter";
import {mapGetters} from "vuex";
import router from "@/router";
import mIcon from "../../Icons/Icon";
import mPaginate1 from "../../Pagination/Paginate1";
import mProductCard309 from "../../Product/Card/ProductCard309";

export default {
  name: "SingleBrand300",
  components: {mIcon, mPaginate1, mProductCard309},
  props: {
    brandLink: {
      default: null
    }
  },
  data() {
    return {
      brand: {}
    };
  },
  computed: {
    ...mapGetters({
      products: "Product/getProducts",
      meta: "Product/getPaginationMeta",
      IsAuthenticated: "User/isAuthenticated",
    })
  },
  methods: {
    getBrandDate(date) {
      return convertToJalaliWithTime(date, "/");
    },
    changePage(page) {
      this.$store.dispatch('Product/setProducts', page);
      router.push({name: "SingleBrand", query: {...router.currentRoute.query, page: page}})
    },
    brandLinkMethod() {
      if (this.brandLink !== null) {
        return this.brandLink;
      }
      return this.$route.params.slug
    }
  },
  mounted() {
    // this.$route.params.slug
    this.$store.dispatch("Brand/showBrand", {slug: this.brandLinkMethod()}).then((res) => {
          this.brand = res.data.data;

          this.$store.commit('Product/setFilters', {key: "is_digital", value: ''});
          this.$store.commit('Product/setFilters', {key: "sort", value: ''});
          this.$store.commit('Product/setFilters', {key: "search", value: ''});
          this.$store.commit('Product/setFilters', {key: "category", value: []});

          this.$store.commit('Product/setFilters', {key: "brand", value: [this.brand.id]});
          this.$store.dispatch('Product/setProducts');
        }
    );
  }
};
</script>

<style scoped>
hr {
  background-color: #707070;
  color: #707070;
  width: 90%;
  display: flex;
  align-self: center;
}


span {
  font-size: 12px;
}

p {
  font-size: 14px;
}

#single-brand-301-image {
  width: 100%;
  border-radius: 4px;
}

#to-course {
  background-color: #212967;
  color: orange;
}

.video-wrapper {
  display: none !important;
}


.see-more-link {
  color: var(--primary);
  font-size: 19px;
  font-weight: bold;
}

.card-button {
  border-radius: 15px;
  color: var(--light-info);
  font-size: 10px;
  font-weight: bold;
  margin-top: 10px;
}

.card-button:hover {
  border-color: white;
}

.card-body-text {
  text-align: center;
  direction: rtl;
}

.card-body {
  padding: 0px;
  padding-bottom: 5px;
}

.card {
  min-height: 370px;
  max-height: auto;
  border-radius: 10px;
  margin: 0px;
  margin-right: 10px;
}


.card .card-img-top {
  height: 200px;
  border-radius: 10px;
  object-fit: cover;
}

.prices {
  font-weight: bold;
  font-size: 17px;
}

.info {
  font-size: 11px;
  font-weight: bold;
}

.b-icon {
  padding: 0px;
  margin: 0px;
  font-size: 10px;
  color: var(--primary);
}

.sticky-discount {
  padding: 5px;
  position: fixed;
  margin: 10px;
  font-size: 12px;
  font-weight: bold;
  color: white;
  background-color: var(--secondary);
  border-radius: 14px;
  border-bottom-right-radius: 0px;
  min-width: max-content;
}

.slider-btn > .b-icon {
  color: var(--primary);
  font-weight: bold;
}

.custom-icon-font-size {
  font-size: 20px;
}

.custom-font-size {
  font-size: 13px;
}

.add-shopping-cart-button {
  font-size: 20px !important;
  color: var(--light-white) !important;
}

</style>